__turbopack_context__.v({
  "baseCarousel": "styles-module-scss-module__GGDTmq__baseCarousel",
  "edgeToEdge": "styles-module-scss-module__GGDTmq__edgeToEdge",
  "header": "styles-module-scss-module__GGDTmq__header",
  "navButtonLeft": "styles-module-scss-module__GGDTmq__navButtonLeft",
  "navButtonRight": "styles-module-scss-module__GGDTmq__navButtonRight",
  "seeMoreLink": "styles-module-scss-module__GGDTmq__seeMoreLink",
});
